/* istanbul ignore file */
export function isDevelopment(): boolean {
  return process.env.APP_ENV === 'development'
}

export function isStaging(): boolean {
  return process.env.APP_ENV === 'staging'
}

export function isProduction(): boolean {
  return process.env.APP_ENV === 'production'
}
